<template>
	<div class="add-alias-ip-container" v-if="dialogVisible">
		<el-form-item class="add-alias-ip" :label="$t('subnet.text.ipAliasRange') | withColon" :required="type === 'list'">
			<el-table :data="aliasIpTableData" v-model="aliasIpTableData" ref="tableList"
				@aliasEvent="$emit('aliasEvent', $event.target.aliasIpTableData)" max-height="250">
				<!--子网范围-->
				<el-table-column prop="subnetId" key="subnetId" min-width="140" :label="$t('subnet.text.subnetRange')">
					<template slot-scope="scope">
						<el-form :model="scope.row" :rules="rules" :ref="scope.$index + '_1'" v-if="scope.row.isEditing">
							<el-form-item prop="subnetObject" ref="subnetObject">
								<el-select v-model="scope.row.subnetObject" @change="subnetChange(scope.row)"
									:placeholder="$t('listPage.placeholder.choose')"
									:class="{ 'custom-select-margin': passAllValidate }">
									<el-option v-for="item in allSubnetRange" :key="item.label" :label="item.label"
										:value="item">
									</el-option>
								</el-select>
							</el-form-item>
							<span></br></br></span>
						</el-form>
						<span v-if="!scope.row.isEditing">
							{{ scope.row.subnetObject.label }}
						</span>
					</template>
				</el-table-column>
				<!--别名IP范围-->
				<el-table-column prop="cidr" key="cidr" width="380" :label="$t('subnet.text.ipAliasRange')">
					<template slot-scope="scope">
						<!--IPv6范围-->
						<div v-if="scope.row.subnetObject.value === ('ipv6')">
							<el-form :model="scope.row" :rules="rules" :ref="scope.$index + '_2'"
								v-if="scope.row.isEditing">
								<el-form-item prop="ipv6Cidr" ref="ipv6Cidr" class="inlineIpv6">
									<el-input v-model="iniCidr" :disabled="true"
										:placeholder="scope.row.subnetObject.ipv6Str" class="iniIpv6">
									</el-input>
									<p class="colon">{{ ':' }}</p>
									<el-input v-model.trim="scope.row.ipv6Cidr"
										:placeholder="$t('subnet.text.ipv6Forexample')" class="iniIpv6">
									</el-input>
									<div class="selsectIpv6Number">
										<el-select v-model="scope.row.lastIpv6Cidr" class="lastIpv6" placeholder=''>
											<el-option v-for="item in ipv6LastCidrGroup" :key="item.value"
												:label="item.label" :value="item.value">
											</el-option>
										</el-select>
									</div>
								</el-form-item>
								<p class="el-form-item-help" v-if="onlyCidrNotStandard"
									:class="{ 'el-form-item-help-error': onlyCidrNotStandard }">
									{{ $t('subnet.help.ipv6CidrStandard') }}
								</p>
								<p class="el-form-item-help" v-if="onlyCidrOutOfRange"
									:class="{ 'el-form-item-help-error': onlyCidrOutOfRange }">
									{{ $t('subnet.help.cidrIpv6OutOfRange') }}
								</p>
								<p class="el-form-item-help" v-if="onlyCidrOverLap"
									:class="{ 'el-form-item-help-error': onlyCidrOverLap }">
									{{ $t('subnet.help.cidrIpv6OverLap') }}
								</p>
								<p class="el-form-item-help" v-if="onlyQuotaExceeded"
									:class="{ 'el-form-item-help-error': onlyQuotaExceeded }">
									{{ $t('subnet.help.quotaExceed') }}
								</p>
								<span v-if="scope.row.isEditing && ruleFormTag.id !== ValidOrErrorConstant.ERROR">
									{{ $t('subnet.help.appointIpAliasRange', [scope.row.subnetObject.label !== '' ?
										scope.row.subnetObject.label : '--']) }}
								</span>
							</el-form>

							<span v-if="!scope.row.isEditing">
								{{ scope.row.subnetObject.ipv6Str + ':' + scope.row.ipv6Cidr + '/' + scope.row.lastIpv6Cidr }}
							</span>
						</div>
						<!--IPv4范围-->
						<div v-else>
							<el-form :model="scope.row" :rules="rules" :ref="scope.$index + '_2'"
								v-if="scope.row.isEditing">
								<el-form-item prop="cidr" ref="cidr">
									<el-input v-model.trim="scope.row.cidr" :placeholder="$t('subnet.text.forExample')"
										:class="{ 'custom-margin-top': passAllValidate }">
									</el-input>
								</el-form-item>
								<p class="el-form-item-help" v-if="onlyCidrNotStandard"
									:class="{ 'el-form-item-help-error': onlyCidrNotStandard }">
									{{ $t('subnet.help.cidrNotStandard') }}
								</p>
								<p class="el-form-item-help" v-if="onlyCidrOutOfRange"
									:class="{ 'el-form-item-help-error': onlyCidrOutOfRange }">
									{{ $t('subnet.help.cidrOutOfRange') }}
								</p>
								<p class="el-form-item-help" v-if="onlyCidrOverLap"
									:class="{ 'el-form-item-help-error': onlyCidrOverLap }">
									{{ $t('subnet.help.cidrOverLap') }}
								</p>
								<p class="el-form-item-help" v-if="onlyCidrIsRetain"
									:class="{ 'el-form-item-help-error': onlyCidrIsRetain }">
									{{ $t('subnet.help.cidrIsRetain') }}
								</p>
								<p class="el-form-item-help" v-if="onlyQuotaExceeded"
									:class="{ 'el-form-item-help-error': onlyQuotaExceeded }">
									{{ $t('subnet.help.quotaExceed') }}
								</p>
								<span v-if="scope.row.isEditing && ruleFormTag.id !== ValidOrErrorConstant.ERROR">
									{{ $t('subnet.help.appointIpAliasRange', [scope.row.subnetObject.label !== '' ?
										scope.row.subnetObject.label : '--']) }}
								</span>
							</el-form>
							<span v-if="!scope.row.isEditing">
								{{ scope.row.cidr }}
							</span>
						</div>
					</template>
				</el-table-column>
				<!--操作-->
				<el-table-column prop="operation" key="operation" min-width="90"
					:label="$t('listPage.tableLabel.operation')">
					<template slot-scope="scope">
						<!--保存-->
						<a href="javascript:void(0)" @click="saveAliasIp(scope, $event)"
							:class="{ 'operation': scope.row.isEditing }" v-if="scope.row.isEditing">
							{{ $t('subnet.text.save') }}
						</a>
						<!--编辑-->
						<a href="javascript:void(0)" @click="editAliasIp(scope)" :class="{ 'operation': scope.row.isEditing }"
							v-if="!scope.row.isEditing">
							{{ $t('subnet.text.edit') }}
						</a>
						<!--删除-->
						<a href="javascript:void(0)" @click="deleteAliasIp(scope)"
							:class="[{ 'a-disabled': aliasIpTableData.length === 1 && type === 'list' }, { 'operation': scope.row.isEditing }]">
							{{ $t('subnet.text.delete') }}
						</a>
					</template>
				</el-table-column>
			</el-table>
		</el-form-item>
	</div>
</template>

<script>
import { ValidOrErrorConstant, AddAliasIpErrorConstant, AliasIpRuleConstant, Ipv6RuleConstant, TargetNetworkInterfaceName } from '@/common/Constants';

export default {
	data() {
		const cidrSelectValidator = (rule, value, callback) => {
			if (!value.label) {
				this.ruleFormTag.id = ValidOrErrorConstant.ERROR
				return callback(new Error(this.$t('subnet.help.subnetNetCannotBeNull')));
			} else {
				this.ruleFormTag.id = ValidOrErrorConstant.VALID
				callback();
			}
		};
		// 校验IPv4范围是否为合规IP
		const cidrInputValidator = (rule, value, callback) => {
			const ipRegex = AliasIpRuleConstant;
			if (!value) {
				this.ruleFormTag.cidr = ValidOrErrorConstant.ERROR
				return callback(new Error(this.$t('subnet.help.aliasIpCannotBeNull')));
			}
			if (!ipRegex.test(value)) {
				this.ruleFormTag.cidr = ValidOrErrorConstant.ERROR
				return callback(new Error(this.$t('subnet.help.cidrNotStandard')));
			}
			this.ruleFormTag.cidr = ValidOrErrorConstant.VALID
			callback();
		};
		// 校验IPv6范围是否为合规IP
		const ipv6CidrInputValidator = (rule, value, callback) => {
			const ipv6Regex = Ipv6RuleConstant;
			if (!value) {
				this.ruleFormTag.ipv6Cidr = ValidOrErrorConstant.ERROR
				return callback(new Error(this.$t('subnet.help.aliasIpCannotBeNull')));
			}
			value = "0:0:0:0:" + value
			if (!ipv6Regex.test(value)) {
				this.ruleFormTag.ipv6Cidr = ValidOrErrorConstant.ERROR
				return callback(new Error(this.$t('subnet.help.ipv6CidrStandard')));
			}
			this.ruleFormTag.ipv6Cidr = ValidOrErrorConstant.VALID
			callback();
		};
		return {
			// 子网范围数据（包括主要CIDR和次要CIDR）
			allSubnetRange: [],
			rules: {
				subnetObject: [
					{ trigger: 'change', required: true, validator: cidrSelectValidator }
				],
				cidr: [
					{
						trigger: 'blur', validator: cidrInputValidator
					}
				],
				ipv6Cidr: [
					{
						trigger: 'blur', validator: ipv6CidrInputValidator
					}
				]
			},
			ruleFormTag: {
				id: ValidOrErrorConstant.VALID,
				cidr: ValidOrErrorConstant.VALID,
				ipv6Cidr: ValidOrErrorConstant.VALID,
				cidrNotStandasrd: ValidOrErrorConstant.VALID,
				cidrOutOfRange: ValidOrErrorConstant.VALID,
				cidrOverLap: ValidOrErrorConstant.VALID,
				cidrIsRetain: ValidOrErrorConstant.VALID,
				cidrRepeated: ValidOrErrorConstant.VALID,
				quotaExceeded: ValidOrErrorConstant.VALID
			},
			// 上一条数据是否未保存
			isRowNotSaved: false,
			dialogVisible: this.visible,
			aliasIpTableDataNotProps: [],
			iniCidr: '',
			ipv4ItemCreate: {},
			ipv4ItemPrimary: {},
			ipv4ItemExtension: {},
			ipv6ItemCreate: {},
			ipv6ItemPrimary: {},
			ipv6ItemExtension: {},
			ipv6LastCidr: 120,
			ipv6LastCidrGroup: [
				{
					value: 120,
					label: '120'
				}, {
					value: 121,
					label: '121'
				}, {
					value: 122,
					label: '122'
				}, {
					value: 123,
					label: '123'
				}, {
					value: 124,
					label: '124'
				}, {
					value: 125,
					label: '125'
				}, {
					value: 126,
					label: '126'
				}, {
					value: 127,
					label: '127'
				}, {
					value: 128,
					label: '128'
				}
			],
		};
	},
	model: {
		prop: 'aliasIpTableData',
		event: 'aliasEvent'
	},
	props: {
		// 子网详情数据
		subnetDetailData: {
			type: Object,
		},
		// 目标网络接口名称
		selectTargetInternetAccessName: {
			type: String
		},
		// 组件是否显示
		visible: {
			type: Boolean,
			default: false
		},
		// 来源(create/list)
		type: {
			type: String
		},
		// 别名IP范围表格数据
		aliasIpTableData: {
			type: Array
		},
		aliasIpRestNumber: {

		},
		aliasIpv6RestNumber: {
		},
	},
	computed: {
		ValidOrErrorConstant: () => ValidOrErrorConstant,
		AddAliasIpErrorConstant: () => AddAliasIpErrorConstant,
		AliasIpRuleConstant: () => AliasIpRuleConstant,
		Ipv6RuleConstant: () => Ipv6RuleConstant,
		onlyCidrNotStandard() {
			return this.ruleFormTag.cidrNotStandasrd === ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.cidrOutOfRange !== ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.cidrOverLap !== ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.cidrIsRetain !== ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.cidr !== ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.ipv6Cidr !== ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.quotaExceeded !== ValidOrErrorConstant.ERROR
		},
		onlyCidrOutOfRange() {
			return this.ruleFormTag.cidrNotStandasrd !== ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.cidrOutOfRange === ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.cidrOverLap !== ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.cidrIsRetain !== ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.cidr !== ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.ipv6Cidr !== ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.quotaExceeded !== ValidOrErrorConstant.ERROR
		},
		onlyCidrOverLap() {
			return this.ruleFormTag.cidrNotStandasrd !== ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.cidrOutOfRange !== ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.cidrOverLap === ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.cidrIsRetain !== ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.cidr !== ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.ipv6Cidr !== ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.quotaExceeded !== ValidOrErrorConstant.ERROR
		},
		onlyCidrIsRetain() {
			return this.ruleFormTag.cidrNotStandasrd !== ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.cidrOutOfRange !== ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.cidrOverLap !== ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.cidrIsRetain === ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.cidr !== ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.ipv6Cidr !== ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.quotaExceeded !== ValidOrErrorConstant.ERROR
		},
		onlyQuotaExceeded() {
			return this.ruleFormTag.cidrNotStandasrd !== ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.cidrOutOfRange !== ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.cidrOverLap !== ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.cidrIsRetain !== ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.cidr !== ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.ipv6Cidr !== ValidOrErrorConstant.ERROR
				&& this.ruleFormTag.quotaExceeded === ValidOrErrorConstant.ERROR
		},
		passAllValidate() {
			return this.ruleFormTag.cidrNotStandasrd === ValidOrErrorConstant.VALID
				&& this.ruleFormTag.cidrOutOfRange === ValidOrErrorConstant.VALID
				&& this.ruleFormTag.cidrOverLap === ValidOrErrorConstant.VALID
				&& this.ruleFormTag.cidrIsRetain === ValidOrErrorConstant.VALID
				&& this.ruleFormTag.cidr === ValidOrErrorConstant.VALID
				&& this.ruleFormTag.ipv6Cidr === ValidOrErrorConstant.VALID
				&& this.ruleFormTag.quotaExceeded === ValidOrErrorConstant.VALID
		}
	},
	mounted() {
		if (this.dialogVisible === true) {
			this.isRowNotSaved = false;
			this.addOneRow();
			this.getSubCidrsList()
		}
	},
	watch: {
		subnetDetailData() {
			if (this.aliasIpTableData.length > 0) {
				this.aliasIpTableData.length = 0
				this.allSubnetRange = []
				this.getSubCidrsList()
				this.isRowNotSaved = false;
				this.addOneRow();
			}
		},
		visible(newVal) {
			this.dialogVisible = newVal
			if (newVal) {
				if (this.aliasIpTableData.length > 0) {
					this.aliasIpTableData.length = 0
					this.allSubnetRange = []
				}
				this.getSubCidrsList()
				this.isRowNotSaved = false;
				this.addOneRow();
			} else {
				this.allSubnetRange = []
				this.ruleFormTag.cidrNotStandasrd = ValidOrErrorConstant.VALID
				this.ruleFormTag.cidrOutOfRange = ValidOrErrorConstant.VALID
				this.ruleFormTag.cidrOverLap = ValidOrErrorConstant.VALID
				this.ruleFormTag.cidrIsRetain = ValidOrErrorConstant.VALID
				this.ruleFormTag.cidr = ValidOrErrorConstant.VALID
				this.ruleFormTag.ipv6Cidr = ValidOrErrorConstant.VALID
				this.ruleFormTag.quotaExceeded = ValidOrErrorConstant.VALID
				this.ipv4ItemCreate = {}
				this.ipv4ItemPrimary = {}
				this.ipv4ItemExtension = {}
				this.ipv6ItemCreate = {}
				this.ipv6ItemPrimary = {}
				this.ipv6ItemExtension = {}
			}
		},
		aliasIpRestNumber(val) {
			if (val === 0) {
				this.allSubnetRange = this.allSubnetRange.filter(item => item.value !== 'ipv4')
			} else {
				if (!this.allSubnetRange.some(item => item.value === 'ipv4')) {
					if (this.type === 'create') {
						this.allSubnetRange.push(this.ipv4ItemCreate)
					} else {
						if (this.selectTargetInternetAccessName === TargetNetworkInterfaceName.primaryNetworkInterface) {
							if (Object.values(this.ipv4ItemPrimary).length > 0) {
								this.allSubnetRange.push(this.ipv4ItemPrimary)
							}
						} else {
							if (Object.values(this.ipv4ItemExtension).length > 0) {
								this.allSubnetRange.push(this.ipv4ItemExtension)
							}


						}
					}
				}
			}
		},
		aliasIpv6RestNumber(val) {
			if (val === 0) {
				this.allSubnetRange = this.allSubnetRange.filter(item => item.value !== 'ipv6')
			} else {
				if (!this.allSubnetRange.some(item => item.value === 'ipv6')) {
					if (this.type === 'create') {
						this.allSubnetRange.push(this.ipv6ItemCreate)
					} else {
						if (this.selectTargetInternetAccessName === TargetNetworkInterfaceName.primaryNetworkInterface) {
							if (Object.values(this.ipv6ItemPrimary).length > 0) {
								this.allSubnetRange.push(this.ipv6ItemPrimary)
							}
						} else {
							if (Object.values(this.ipv6ItemExtension).length > 0) {
								this.allSubnetRange.push(this.ipv6ItemExtension)
							}

						}
					}
				}
			}
		},
		selectTargetInternetAccessName() {

		}
	},
	methods: {
		// 删除当前行
		deleteAliasIp(scope) {
			if (this.aliasIpTableData.length === 1 && this.type === 'list') {
				return false;
			}
			this.aliasIpTableData.splice(scope.$index, 1);
			if (this.type === 'create' && this.aliasIpTableData.length === 0) {
				this.$emit('update:visible', false);
			}
			this.isRowNotSaved = false
		},
		// 保存当前行
		async saveAliasIp(scope, e) {
			// 除点击事件外不触发
			if (!e.x || !e.y) return;
			let initValid = true;
			if (scope.row.cidr) {
				this.$refs[`${scope.$index}_2`].validateField('cidr');
				this.ruleFormTag.cidr = this.$refs.cidr.validateState;
			}
			if (scope.row.ipv6Cidr) {
				this.$refs[`${scope.$index}_2`].validateField('ipv6Cidr');
				this.ruleFormTag.ipv6Cidr = this.$refs.ipv6Cidr.validateState;
			}
			this.$refs[`${scope.$index}_1`].validateField('subnetObject')
			this.ruleFormTag.id = this.$refs.subnetObject.validateState;
			// 通过前端必填和IP地址合法校验，调用后端接口校验
			if (this.ruleFormTag.ipv6Cidr !== ValidOrErrorConstant.ERROR && this.ruleFormTag.cidr !== ValidOrErrorConstant.ERROR && this.ruleFormTag.id !== ValidOrErrorConstant.ERROR) {
				await this.checkAliasIps(scope.row);
			}
			for (let i = 1; i <= 2; i++) {
				this.$refs[`${scope.$index}_${i}`].validate((valid) => {
					initValid = initValid && valid;
					if (!valid) {
						return false;
					}
				});
			}
			if (initValid && this.passAllValidate) {
				this.isRowNotSaved = false;
				scope.row.isEditing = false;
			}
		},
		// 编辑当前行
		editAliasIp(scope) {
			scope.row.isEditing = true;
		},

		// 添加一行
		addOneRow() {
			if (this.isRowNotSaved) {
				return false
			}
			const row = {
				subnetObject: {
					label: '',
					value: ''
				},
				'cidr': '',
				'ipv6Cidr': '',
				'lastIpv6Cidr': 120,
				isEditing: true
			};
			this.aliasIpTableData.push(row);
			this.isRowNotSaved = true;
			this.$nextTick(function () {
				this.$refs.tableList.bodyWrapper.scrollTop = this.$refs.tableList.bodyWrapper.scrollHeight;
			})
		},
		//截取ipv6前64位参数
		getIPv6ConstantNumber(val) {
			var n = val.indexOf("::");
			var str = val.substr(0, n)
			return str;
		},
		// 获取当前子网下的所有次要CIDR
		getSubCidrsList() {
			if (this.subnetDetailData.region && this.subnetDetailData.subnetId) {
				let subnetId;
				if (this.type === 'create') {
					subnetId = this.subnetDetailData.subnetId
				} else {
					subnetId = this.selectTargetInternetAccessName === TargetNetworkInterfaceName.primaryNetworkInterface ? this.subnetDetailData.subnetId : this.subnetDetailData.extensionSubnetId
				}
				const param = {
					region: this.subnetDetailData.region,
					subnetId: subnetId
				};
				let tempString = '';
				if (this.type === 'create') {
					tempString = this.subnetDetailData.cidr

				} else {
					tempString = this.selectTargetInternetAccessName === TargetNetworkInterfaceName.primaryNetworkInterface ? this.subnetDetailData.subnetCidr : this.subnetDetailData.extensionSubnetCidr
				}
				if (this.type === 'create') {
					this.allSubnetRange.push({
						value: 'ipv4',
						sid: this.subnetDetailData.subnetId,
						label: `${this.$t('subnet.text.mainCidr')}(${tempString})`
					});
					this.ipv4ItemCreate = {
						value: 'ipv4',
						sid: this.subnetDetailData.subnetId,
						label: `${this.$t('subnet.text.mainCidr')}(${tempString})`
					}
				} else {
					if (this.selectTargetInternetAccessName === TargetNetworkInterfaceName.primaryNetworkInterface) {
						this.allSubnetRange.push({
							value: 'ipv4',
							sid: this.subnetDetailData.subnetId,
							label: `${this.$t('subnet.text.mainCidr')}(${tempString})`
						});
						this.ipv4ItemPrimary = {
							value: 'ipv4',
							sid: this.subnetDetailData.subnetId,
							label: `${this.$t('subnet.text.mainCidr')}(${tempString})`
						}
						if (this.aliasIpRestNumber === 0) { this.allSubnetRange = this.allSubnetRange.filter(item => item.value !== 'ipv4') }
					} else {
						this.allSubnetRange.push({
							value: 'ipv4',
							sid: this.subnetDetailData.extensionSubnetId,
							label: `${this.$t('subnet.text.mainCidr')}(${tempString})`
						});
						this.ipv4ItemExtension = {
							value: 'ipv4',
							sid: this.subnetDetailData.extensionSubnetId,
							label: `${this.$t('subnet.text.mainCidr')}(${tempString})`
						}
						if (this.aliasIpRestNumber === 0) { this.allSubnetRange = this.allSubnetRange.filter(item => item.value !== 'ipv4') }
					}
				}
				let ipv6String = '';
				if (this.type === 'create') {
					ipv6String = this.subnetDetailData.ipv6Cidr
				} else {
					ipv6String = this.selectTargetInternetAccessName === TargetNetworkInterfaceName.primaryNetworkInterface ? this.subnetDetailData.subnetIpv6Cidr : this.subnetDetailData.extensionSubnetIpv6Cidr
				}
				if (ipv6String) {
					if (this.type === 'create') {
						this.allSubnetRange.push({
							value: 'ipv6',
							sid: this.subnetDetailData.subnetId,
							ipv6Str: `${this.getIPv6ConstantNumber(ipv6String)}`,
							label: `${this.$t('subnet.text.mainIpv6Cidr')}(${ipv6String})`
						});
						this.ipv6ItemCreate = {
							value: 'ipv6',
							sid: this.subnetDetailData.subnetId,
							ipv6Str: `${this.getIPv6ConstantNumber(ipv6String)}`,
							label: `${this.$t('subnet.text.mainIpv6Cidr')}(${ipv6String})`
						}
					} else {
						if (this.selectTargetInternetAccessName === TargetNetworkInterfaceName.primaryNetworkInterface) {
							this.allSubnetRange.push({
								value: 'ipv6',
								sid: this.subnetDetailData.subnetId,
								ipv6Str: `${this.getIPv6ConstantNumber(ipv6String)}`,
								label: `${this.$t('subnet.text.mainIpv6Cidr')}(${ipv6String})`
							});
							this.ipv6ItemPrimary = {
								value: 'ipv6',
								sid: this.subnetDetailData.subnetId,
								ipv6Str: `${this.getIPv6ConstantNumber(ipv6String)}`,
								label: `${this.$t('subnet.text.mainIpv6Cidr')}(${ipv6String})`
							}
							if (this.aliasIpv6RestNumber === 0) { this.allSubnetRange = this.allSubnetRange.filter(item => item.value !== 'ipv6') }
						} else {
							this.allSubnetRange.push({
								value: 'ipv6',
								sid: this.subnetDetailData.extensionSubnetId,
								ipv6Str: `${this.getIPv6ConstantNumber(ipv6String)}`,
								label: `${this.$t('subnet.text.mainIpv6Cidr')}(${ipv6String})`
							});
							this.ipv6ItemExtension = {
								value: 'ipv6',
								sid: this.subnetDetailData.extensionSubnetId,
								ipv6Str: `${this.getIPv6ConstantNumber(ipv6String)}`,
								label: `${this.$t('subnet.text.mainIpv6Cidr')}(${ipv6String})`
							}
							if (this.aliasIpv6RestNumber === 0) { this.allSubnetRange = this.allSubnetRange.filter(item => item.value !== 'ipv6') }
						}
					}
				}
				if (subnetId) {
					Ajax.get('/api/cps/listSecondaryCidrs', param)
						.then((res) => {
							const data = res.data;
							const list = data.secondaryCidrs;
							for (let i = 0; i < list.length; i++) {
								this.allSubnetRange.push({
									label: `${list[i].name}(${list[i].cidr})`,
									sid: `${list[i].secondaryCidrId}`,
									value: `${list[i].secondaryCidrId}`
								});
							}
						})
						.finally(() => {
						});
				}

			}
		},
		// 检测别名IP
		async checkAliasIps(row) {
			this.ruleFormTag.cidrNotStandasrd = ValidOrErrorConstant.VALID
			this.ruleFormTag.cidrOutOfRange = ValidOrErrorConstant.VALID
			this.ruleFormTag.cidrOverLap = ValidOrErrorConstant.VALID
			this.ruleFormTag.cidrIsRetain = ValidOrErrorConstant.VALID
			this.ruleFormTag.cidr = ValidOrErrorConstant.VALID
			this.ruleFormTag.ipv6Cidr = ValidOrErrorConstant.VALID
			this.ruleFormTag.quotaExceeded = ValidOrErrorConstant.VALID
			this.ruleFormTag.cidrRepeated = false;
			const tempParam = [];
			if (this.aliasIpTableData.length > 1) {
				for (let i = 0; i <= this.aliasIpTableData.length - 2; i++) {
					if (this.aliasIpTableData[this.aliasIpTableData.length - 1].cidr && this.aliasIpTableData[this.aliasIpTableData.length - 1].cidr
						=== this.aliasIpTableData[i].cidr) {
						this.ruleFormTag.cidrRepeated = true
					}
					if (this.aliasIpTableData[this.aliasIpTableData.length - 1].ipv6Cidr && this.aliasIpTableData[this.aliasIpTableData.length - 1].ipv6Cidr
						=== this.aliasIpTableData[i].ipv6Cidr) {
						this.ruleFormTag.cidrRepeated = true
					}
				}
			}

			if (this.ruleFormTag.cidrRepeated) {
				this.ruleFormTag.cidrOverLap = ValidOrErrorConstant.ERROR;
				return false
			}
			for (const item of this.aliasIpTableData) {
				tempParam.push({
					id: item.subnetObject.sid,
					cidr: item.ipv6Cidr ? (item.subnetObject.ipv6Str + ':' + item.ipv6Cidr + '/' + item.lastIpv6Cidr) : item.cidr,
					scope: item.ipv6Cidr ? "ipv6" : "ipv4"
				})
			}
			// subnetId条件处理，创建页、列表页、详情页
			let subnetId;
			if (this.type === 'create') {
				subnetId = this.subnetDetailData.subnetId;
			} else {
				subnetId = this.selectTargetInternetAccessName === TargetNetworkInterfaceName.primaryNetworkInterface ? this.subnetDetailData.subnetId : this.subnetDetailData.extensionSubnetId;
			}
			const params = Object.assign({ aliasIps: tempParam }, {
				region: this.subnetDetailData.region,
				subnetId: subnetId,
				instanceId: this.subnetDetailData.instanceId
			});
			await Ajax.post('/api/bm/checkAliasIps', params, {
				headers: {
					'Content-Type': 'application/json'
				}
			})
				.then((res) => {
					const errorList = res.data.errorList
					// 如果添加失败
					if (errorList.length >= 1 && errorList[0].cidr) {
						switch (errorList[errorList.length - 1].message) {
							case AddAliasIpErrorConstant.CIDR_NOT_STANDARD: {
								this.ruleFormTag.cidrNotStandasrd = ValidOrErrorConstant.ERROR;
								this.ruleFormTag.cidrOutOfRange = ValidOrErrorConstant.VALID;
								this.ruleFormTag.cidrOverLap = ValidOrErrorConstant.VALID;
								this.ruleFormTag.cidrIsRetain = ValidOrErrorConstant.VALID;
								this.ruleFormTag.quotaExceeded = ValidOrErrorConstant.VALID;
								break;
							}
							case AddAliasIpErrorConstant.CIDR_OUT_OF_RANGE: {
								this.ruleFormTag.cidrOutOfRange = ValidOrErrorConstant.ERROR;
								this.ruleFormTag.cidrNotStandasrd = ValidOrErrorConstant.VALID;
								this.ruleFormTag.cidrOverLap = ValidOrErrorConstant.VALID;
								this.ruleFormTag.cidrIsRetain = ValidOrErrorConstant.VALID;
								this.ruleFormTag.quotaExceeded = ValidOrErrorConstant.VALID;
								break;
							}
							case AddAliasIpErrorConstant.CIDR_OVERLAP: {
								this.ruleFormTag.cidrOverLap = ValidOrErrorConstant.ERROR;
								this.ruleFormTag.cidrNotStandasrd = ValidOrErrorConstant.VALID;
								this.ruleFormTag.cidrOutOfRange = ValidOrErrorConstant.VALID;
								this.ruleFormTag.cidrIsRetain = ValidOrErrorConstant.VALID;
								this.ruleFormTag.quotaExceeded = ValidOrErrorConstant.VALID;
								break;
							}
							case AddAliasIpErrorConstant.CIDR_IS_NETWORK_IP:
							case AddAliasIpErrorConstant.CIDR_IS_GATEWAY_IP:
							case AddAliasIpErrorConstant.CIDR_IS_BROADCAST_IP:
							case AddAliasIpErrorConstant.CIDR_IS_RETAIN: {
								this.ruleFormTag.cidrIsRetain = ValidOrErrorConstant.ERROR;
								this.ruleFormTag.cidrNotStandasrd = ValidOrErrorConstant.VALID;
								this.ruleFormTag.cidrOutOfRange = ValidOrErrorConstant.VALID;
								this.ruleFormTag.cidrOverLap = ValidOrErrorConstant.VALID;
								this.ruleFormTag.quotaExceeded = ValidOrErrorConstant.VALID;
								break;
							}
							case AddAliasIpErrorConstant.QUOTA_EXCEEDED: {
								this.ruleFormTag.quotaExceeded = ValidOrErrorConstant.ERROR;
								this.ruleFormTag.cidrIsRetain = ValidOrErrorConstant.VALID;
								this.ruleFormTag.cidrNotStandasrd = ValidOrErrorConstant.VALID;
								this.ruleFormTag.cidrOutOfRange = ValidOrErrorConstant.VALID;
								this.ruleFormTag.cidrOverLap = ValidOrErrorConstant.VALID;
								break;
							}
							default:
						}
					} else {
						this.ruleFormTag.cidrNotStandasrd = ValidOrErrorConstant.VALID;
						this.ruleFormTag.cidrOutOfRange = ValidOrErrorConstant.VALID;
						this.ruleFormTag.cidrOverLap = ValidOrErrorConstant.VALID;
						this.ruleFormTag.cidrIsRetain = ValidOrErrorConstant.VALID;
						this.ruleFormTag.quotaExceeded = ValidOrErrorConstant.VALID;
					}
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				})
				.finally(() => {
				});
		},
		subnetChange(val) {
			val.cidr = '';
			val.ipv6Cidr = '';
			val.lastIpv6Cidr = 120
			this.ruleFormTag.cidrNotStandasrd = ValidOrErrorConstant.VALID
			this.ruleFormTag.cidrOutOfRange = ValidOrErrorConstant.VALID
			this.ruleFormTag.cidrOverLap = ValidOrErrorConstant.VALID
			this.ruleFormTag.cidrIsRetain = ValidOrErrorConstant.VALID
			this.ruleFormTag.cidr = ValidOrErrorConstant.VALID
			this.ruleFormTag.ipv6Cidr = ValidOrErrorConstant.VALID
			this.ruleFormTag.quotaExceeded = ValidOrErrorConstant.VALID
			this.ruleFormTag.cidrRepeated = false;

		},
		checkHasIp(arr, val) {
			return arr.some(item => {
				item === val
			})
		},
	}
};
</script>

<style lang="scss">
.add-alias-ip-container {
	.custom-select-margin.el-select {
		margin-top: 10px;
	}

	.custom-margin-top.el-input {
		margin-bottom: 10px;
	}

	.cell {
		.el-form-item-name-help.input-tip {
			margin-left: -10px
		}

		.operation {
			margin-bottom: 18px
		}
	}

	.a-disabled {
		color: #9e9e9e;
		cursor: not-allowed;
	}

	.el-form-item__content {
		.el-select {
			width: 100% !important
		}
	}

	.inlineIpv6 {
		.el-form-item__content {
			display: flex;
			flex-wrap: wrap;
		}

	}

	.iniIpv6 {
		width: 130px !important;


	}

	.selsectIpv6Number {
		width: 70px;
		margin-left: 5px;
		margin-right: 16px;
	}

	.colon {
		margin-left: 5px;
		margin-right: 5px;
	}

	.el-table .cell {
		padding: 0 5px;
	}
}

.create-container {
	.sub-cidr-container {
		.el-select {
			width: 80% !important;
		}
	}
}

.instance-detail {
	.el-form {
		padding-right: 0px;
		// p {
		// 	margin-bottom: 7px !important
		// }
	}

	.el-table {
		.cell {
			padding-right: 0px
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/common/addAliasIpRange/AddAliasIpRange.vue